import { render } from "./RunPlacementPickers.vue?vue&type=template&id=74c0660a"
import script from "./RunPlacementPickers.vue?vue&type=script&lang=js"
export * from "./RunPlacementPickers.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__